import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon, name, ...props }) => {
  let IconComponent;

  try {
    if (icon) {
      IconComponent = icon;
    } else if (name) {
      // Handle both "Target" and "FiTarget" formats
      const iconName = name.startsWith('Fi') ? name : `Fi${name}`;
      IconComponent = FiIcons[iconName];
    }
  } catch (e) {
    console.error(`Error loading icon: ${name}`, e);
    IconComponent = null;
  }

  // Return the icon component or a fallback alert icon
  return IconComponent ? React.createElement(IconComponent, props) : <FiAlertTriangle {...props} />;
};

export default SafeIcon;